import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryRestrictionService } from '@app/country-restriction/country-restriction.service';
import { CountryRestrictionComponent } from '@app/country-restriction/country-restriction.component';
import { CountryRestrictionGuard } from '@app/country-restriction/country-restriction.guard';
import { I18nService } from '@app/core';
import { TranslateModule } from '@ngx-translate/core';
import { CountryRegistrationRestrictionComponent } from '@app/country-restriction/country-registration-restriction.component';
import { CountryRegistrationRestrictionGuard } from '@app/country-restriction/country-registration-restriction.guard';
import { CountryRegistrationRestrictionService } from '@app/country-restriction/country-registration-restriction.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    CountryRestrictionComponent,
    CountryRegistrationRestrictionComponent,
  ],
  exports: [
    CountryRestrictionComponent,
    CountryRegistrationRestrictionComponent,
  ],
  providers: [
    CountryRestrictionService,
    CountryRegistrationRestrictionService,
    CountryRestrictionGuard,
    CountryRegistrationRestrictionGuard,
    I18nService
  ],
})
export class CountryRestrictionModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/country-restriction/country-restriction.module.ts